import {h, Fragment} from "preact"
import { useFacets, useProductFilters } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import SortDropdown from "./elements/SortDropdown"
import {transformSavingsAndOffersFacetData, transformCategoriesFacetData} from "../helpers"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for={toggleButtonId}
        >
            <Icon name="close" />
        </label>
    )
}

export default function SideBar() {
    const { loading, facets: unfilteredFacets } = useFacets();
    const { removeAll } = useProductFilters();

    const body = document.querySelector("body");
    const actualPageType = body?.getAttribute("data-page-type")?.toLowerCase() || "";
    const isBrandPage = actualPageType.includes("brand");

    const facets = unfilteredFacets.filter(facet => !isBrandPage || facet.name !== "Brand");

    function closeSidebar() {
        const closeBtn = document.querySelector(".ns-close-sidebar");
        if(closeBtn){
            closeBtn.click();
        }
    }

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-d-none"
                for={toggleButtonId}
            />
            <div
            // ns-d-md-block
                class="ns-sidebar-wrapper ns-d-none ns-h-100 ns-col-3 ns-col-l-2"
                // style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline ns-p-4">
                        <span class="ns-font-medium ns-font-5 ns-color-black">Filter &amp; Sort</span>
                        <ToggleSidebarButton />
                    </div>
                    <div class="ns-sidebar-menu">
                        <SortDropdown />
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        if (facet.name === 'Savings & Offers') {
                                            // Transform the facet data before passing it to the Facet component
                                            const transformedData = transformSavingsAndOffersFacetData(facet?.data);
                                            if(transformedData.length > 0){
                                                return <Facet key={facet.id} facet={{ ...facet, data: transformedData }} />;
                                            } else {
                                                return null;
                                            }
                                            // console.log(transformedData);
                                            
                                        } else if (facet.name === 'Category') {
                                            const transformedCategoryData = transformCategoriesFacetData(facet?.data);
                                            // console.log(transformedCategoryData);
                                            if(transformedCategoryData.length > 0){
                                                return <Facet key={facet.id} facet={{ ...facet, data: transformedCategoryData }} />;
                                            } else {
                                                return null;
                                            }
                                            
                                        } else {
                                            // If the facet name does not match, return the Facet component without transforming the data
                                            return <Facet key={facet.id} facet={facet} />;
                                        }
                                        // return <Facet key={facet.id} facet={facet}/>
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet}/>
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
                <div class="ns-apply-btn-container ns-d-flex ns-align-items-center ns-justify-content-between ns-p-4">
                    <button class="ns-apply-btn" onClick={() => {
                        closeSidebar();
                    }}>View Results</button>
                    <button class="ns-clear-filters-btn" onClick={() => {
                            removeAll()
                        }}
                    >
                        <Icon name="close" />
                        <span
                        class="ns-anchor ns-d-block">
                            Clear Filters
                        </span>
                    </button>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
